import React from "react";
import { Modal, Box } from "@mui/material";
import "./maintenance-modal.scss";

type MaintenanceModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function MaintenanceModal({
  open,
  onClose,
}: MaintenanceModalProps): JSX.Element {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="maintenance-modal"
      aria-labelledby="maintenance-title"
      aria-describedby="maintenance-description"
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        },
      }}
    >
      <Box className="maintenance-content">
        <button className="maintenance-close" onClick={onClose}>
          ✕
        </button>
        <div className="maintenance-icon">🔧</div>
        <p className="maintenance-message">
          This agent is currently under maintenance and temporarily unavailable.
          <br />
          <br />
          We're working to bring it back online soon. Please check back later or
          explore other available agents in the meantime.
        </p>
        <button className="maintenance-button" onClick={onClose}>
          Got it
        </button>
      </Box>
    </Modal>
  );
}
